"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/RoomHeader.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);



var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');


var _Header = require('web/components/VideoRooms/Room/Header'); var _Header2 = _interopRequireDefault(_Header);










// memo keeps connect()'s bailout on unchanged own props.
const RoomHeader = _react.memo.call(void 0, function RoomHeader ({
  roomKey,
  onBack,
  onRoomShare,
  onRoomLinkCopy,
  gotoMeeting,
  showNoticeBar,
}) {
  const videoRoom = _hooks.useAppSelector.call(void 0, state => _videoRoom.selectVideoRoomByKey.call(void 0, state, roomKey))
  const activeParticipantsCount = _hooks.useAppSelector.call(void 0, state =>
    _videoRoom.selectVideoRoomActiveParticipantsCount.call(void 0, state, roomKey))

  const handleRoomRename = _react.useCallback.call(void 0, (RoomName) =>
    _actions2.default.renameVideoRoom({ RoomKey: roomKey, RoomName })
      .then(() => showNoticeBar({ text: 'Meeting room renamed.' }))
      .catch(() => showNoticeBar({ type: 'warning', text: 'Failed to rename meeting room.' })),
  [roomKey, showNoticeBar])

  const handleRoomArchive = _react.useCallback.call(void 0, () =>
    _actions2.default.archiveVideoRoom({ RoomKey: roomKey })
      .then(() => showNoticeBar({ text: 'Meeting room was archived.' }))
      .catch(() => showNoticeBar({ type: 'warning', text: 'Failed to archive meeting room.' })),
  [roomKey, showNoticeBar])

  // Existing behaviour kept: `.then` receives the result of calling
  // showNoticeBar, so the notice shows at once, before the unarchive resolves.
  // (Same call order as the JS: the unarchive starts, then the notice shows.)
  const handleRoomUnarchive = _react.useCallback.call(void 0, () => {
    const unarchiving = _actions2.default.unarchiveVideoRoom({ RoomKey: roomKey })
    // SAFETY: showNoticeBar returns nothing, so `.then` gets undefined and
    // ignores it, as in the JS.
    const onUnarchived = showNoticeBar({ text: 'Meeting room was unarchived.' }) 
    return unarchiving
      .then(onUnarchived)
      .catch(() => showNoticeBar({ type: 'warning', text: 'Failed to unarchive meeting room.' }))
  }, [roomKey, showNoticeBar])

  if (!videoRoom) return null

  // SAFETY: rooms in the store carry DisplayName and RoomLink once fetched or
  // listed; the header rendered whatever they held, as in the JS.
  const roomName = videoRoom.DisplayName 
  // SAFETY: as above.
  const roomLink = videoRoom.RoomLink 

  return (
    _react2.default.createElement(_Header2.default, {
      key: videoRoom.RoomKey,
      onBack: onBack,
      onRoomShare: onRoomShare,
      onRoomLinkCopy: onRoomLinkCopy,
      gotoMeeting: gotoMeeting,
      roomName: roomName,
      roomLink: roomLink,
      isRoomArchived: videoRoom.Archived,
      activeParticipantsCount: activeParticipantsCount,
      onRoomRename: handleRoomRename,
      onRoomArchive: handleRoomArchive,
      onRoomUnarchive: handleRoomUnarchive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
    )
  )
})

exports. default = RoomHeader
